var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',[_c('b-col',{staticStyle:{"max-width":"45px"}},[_c('b-spinner',{attrs:{"label":"Loading..."}})],1),_c('b-col',{staticStyle:{"padding-top":"3px"}},[_vm._v("Loading...")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }